import { Button } from "@devhop/ui";
import { Building2Icon, PencilIcon } from "lucide-react";

export function PayoutBankAccountCard({
  bank,
  onEdit,
  editDisabled,
}: {
  bank: {
    bankName?: string | null;
    bankAccount?: string | null;
    accountName?: string | null;
  };
  onEdit?: () => void;
  editDisabled?: boolean;
}) {
  const hasBank =
    Boolean(bank.bankName) ||
    Boolean(bank.bankAccount) ||
    Boolean(bank.accountName);

  return (
    <div className="min-w-[200px] max-w-full rounded-lg border bg-muted/25 p-3 text-sm leading-snug">
      <div className="mb-2 flex items-start justify-between gap-2">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Building2Icon className="size-3.5 shrink-0" />
          <span className="text-xs uppercase tracking-wide">ບັນຊີ</span>
        </div>
        {onEdit ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="-mt-1 -mr-1 h-7 shrink-0 px-2 text-xs"
            disabled={editDisabled}
            onClick={onEdit}
          >
            <PencilIcon className="size-3" />
            ແກ້ໄຂບັນຊີ
          </Button>
        ) : null}
      </div>
      {hasBank ? (
        <>
          {bank.bankName ? (
            <div className="break-words font-medium">{bank.bankName}</div>
          ) : null}
          {bank.bankAccount ? (
            <div className="mt-1 break-all font-mono text-muted-foreground text-xs tracking-wide">
              {bank.bankAccount}
            </div>
          ) : null}
          {bank.accountName ? (
            <div className="mt-1 break-words text-muted-foreground">
              {bank.accountName}
            </div>
          ) : null}
        </>
      ) : (
        <p className="text-muted-foreground text-sm">ຍັງບໍ່ມີຂໍ້ມູນບັນຊີ</p>
      )}
    </div>
  );
}
